export const SHOWERRORMESSAGE = 'SHOWERRORMESSAGE'
export const HIDEERRORMESSAGE = 'HIDEERRORMESSAGE'
